/**
 * FE-C2g batch-7: Billing console — contract paths for billing.route.js.
 */

import { buildContractPath } from "./api/contract-client.js";

export const BILLING_CONSOLE_TIMEOUT_MS = 16000;

/** @param {string} [filter] — all | paid | unpaid */
export function buildBillingInvoicesPath(filter = "all") {
  return buildContractPath("get__billing_invoices", { query: { filter } });
}

export function buildBillingUsagePath() {
  return buildContractPath("get__billing_usage");
}
